import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text, DateTime } from 'components/common/Elements/Elements';

import { underlineToSpace } from 'utils/common';

import classes from './Messages.module.scss';

const Messages = ({ data }) => (
  <div className={classes.info}>
    <div className={classes.title}>
      <DateTime date={data.messageCreatedAt} time />
      <Text
        className={cn(
          classes.status,
          data.messageStatus === 'completed'
            ? classes.status_green
            : data.messageStatus === 'in_progress'
            ? classes.status_yellow
            : data.messageStatus === 'scheduled' && classes.status_blue
        )}
      >
        {underlineToSpace(data.messageStatus)}
      </Text>
    </div>
    <Text type={'p'} size={4} className={classes.message}>
      {data.message}
    </Text>
  </div>
);

Messages.propTypes = {
  data: PropTypes.object.isRequired
};

export default Messages;
